import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Package, ShoppingBag, Users, Palette, LogOut, Layers, Instagram } from "lucide-react";
import { Toaster } from "sonner";

const LINKS = [
  { to: "/admin/analytics", label: "Analytics", icon: LayoutDashboard },
  { to: "/admin/products", label: "Products", icon: Package },
  { to: "/admin/shop-the-look", label: "Shop the Look", icon: Layers },
  { to: "/admin/instagram", label: "Instagram Sync", icon: Instagram },
  { to: "/admin/orders", label: "Orders", icon: ShoppingBag },
  { to: "/admin/leads", label: "Leads", icon: Users },
  { to: "/admin/design-enquiries", label: "Design Uploads", icon: Palette },
];

export default function AdminLayout() {
  const { user, loading, logout } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!user) nav("/admin/login");
    else if (user.role !== "admin") nav("/");
  }, [user, loading]);

  if (loading || !user || user.role !== "admin") {
    return <div className="min-h-screen flex items-center justify-center text-[#8A8680] font-micro">Loading…</div>;
  }

  return (
    <div className="min-h-screen" style={{ background: "#0B0B0C" }} data-testid="admin-layout">
      <Toaster theme="dark" position="top-right" />
      <div className="flex">
        <aside className="w-64 min-h-screen p-8" style={{ background: "#141414", borderRight: "1px solid var(--hairline)" }}>
          <div className="font-serif text-[#EDE4D3] text-2xl mb-1">Teak Studio</div>
          <div className="font-micro text-[#B8895C] mb-12">Admin</div>
          <nav className="space-y-2">
            {LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`admin-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-4 py-3 font-micro transition-all duration-500 ${
                    isActive ? "text-[#B8895C] bg-[#0B0B0C]" : "text-[#D8D6D1] hover:text-[#B8895C]"
                  }`
                }
                style={({ isActive }) => (isActive ? { borderLeft: "1px solid #B8895C" } : {})}
              >
                <l.icon size={16} strokeWidth={1.25} /> {l.label}
              </NavLink>
            ))}
          </nav>
          <button onClick={async () => { await logout(); nav("/admin/login"); }} className="mt-12 flex items-center gap-3 font-micro text-[#8A8680] hover:text-[#B8895C] transition-colors" data-testid="admin-logout">
            <LogOut size={16} strokeWidth={1.25} /> Logout
          </button>
        </aside>
        <main className="flex-1 min-h-screen p-12">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
